import api from "../Api/feathers-client";
import { spread, union, concat, startCase } from "lodash";
import packageJson from "../../package.json";
import axios from "axios";

// Call backend service to insert logs
export const userLogs = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").create(
        {
          ...data,
          outcome: {
            ...data.outcome,
            deviceType: "web",
            applicationVersion: packageJson.version,
          },
        },
        {},
      );

      resolve({
        status: 200,
        message: "User-log Created",
        data: response,
      });
    } catch (error) {
      resolve({
        status: 500,
        message: "something wrong!",
        data: error,
      });
    }
  });
};

// fetch user logs data
export const getUserLogs = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find(params);
      resolve({
        status: 200,
        message: "User logs data",
        data: response,
      });
    } catch (error) {
      resolve("error", error);
    }
  });
};

// Final Duration Calculation
export const durationCalculate = (duration, startTime) => {
  let dateObj = new Date();
  var finalDuration = 0;
  if (startTime != 0) {
    finalDuration = +dateObj.getTime() - +startTime + Number(duration);
  }

  return finalDuration;
};

export const unicodeToString = (theString) => {
  if (theString != undefined) {
    return theString.replace(/\\u[\dA-F]{4}/gi, (match) => {
      return String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
    });
  }
};

export const concatAllArrays = spread(union);

export const concatAllArraysWithDuplicate = spread(concat);

export const shuffle = (array) => {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const dynamicSort = (property) => {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
};

export const joinByKeys = (obj = {}, props = [], separator = "") => {
  // empty array.
  let arr = [];
  // push props to array
  props.forEach((p) => arr.push(obj[p]));
  // return the joined array.
  return arr.join(separator);
};

export const hhmmssToMilli = (hms) => {
  let time = hms.split(":"); // split it at the colons
  let seconds = time[2].split(".");
  let milliseconds = 0;
  if (seconds.length > 1) {
    milliseconds = +time[0] * 60 * 60 + +time[1] * 60 + +seconds[0];
    milliseconds = +milliseconds * 1000 + +seconds[1];
  } else {
    milliseconds = +time[0] * 60 * 60 + +time[1] * 60 + +seconds[0];
    milliseconds = +milliseconds * 1000;
  }

  return milliseconds;
};

export const blobToBase64 = (blobUrl) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blobUrl);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const randomNumber = (range) => {
  return Math.floor(Math.random() * +range);
};

export const generateRandomId = (len) => {
  let charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let id = "";
  for (let i = 1; i < len; i++) {
    let randPos = Math.floor(Math.random() * charSet.length);
    id += charSet[randPos];
  }
  return id;
};

// Call Internet is available in server or not
export const checkInternet = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("check-internet-service").get(null, {});
      resolve({
        status: 200,
        message: "Internet Availability",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

// File read
export const readFile = async (filename, path) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api
        .service("files-read")
        .get(filename, { query: { fileDirPath: path, isExist: true } });
      resolve({
        status: 200,
        message: "users",
        response,
      });
    } catch (error) {
      resolve(error);
    }
  });
};

//Upload files
export const singleFileUpload = async (files, fileType) => {
  let formData = new FormData();
  formData.append("file", files);
  formData.append("type", fileType);
  // console.log("formData====>",formData);
  return new Promise(async (resolve, reject) => {
    try {
      let url = process.env.REACT_APP_SERVER_API + ":3131";
      let res = await axios.post(`${url}/uploads`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": "YRS/DzcxC0+58jfh/kphhA6zz4Y=",
        },
      });
      resolve({
        status: res.status,
        message: res.statusText,
        data: res.data,
      });
    } catch (error) {
      console.error("Error uploading file:", error);
      resolve(error);
    }
  });
};

export const downloadFile = async (filePath, fileName) => {
  let response = await fetch(filePath, {
    method: "GET",
  });
  if (!response.ok) {
    throw new Error("Failed to download file");
  }
  let blob = await response.blob();
  let url = window.URL.createObjectURL(blob);
  let a = document.createElement("a");
  a.href = url;
  a.download = fileName; // customize file name
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url); // cleanup
};

export const capitalizeFirstLetter = ([first = "", ...rest]) => {
  return [first.toUpperCase(), ...rest].join("");
};

function xorEncrypt(str, key) {
  let result = "";
  for (let i = 0; i < str.length; i++) {
    result += String.fromCharCode(
      str.charCodeAt(i) ^ key.charCodeAt(i % key.length),
    );
  }
  return result;
}

function base64UrlEncode(str) {
  return btoa(str)
    .replace(/\+/g, "-") // URL-safe
    .replace(/\//g, "_")
    .replace(/=+$/, ""); // remove padding
}

function base64UrlDecode(str) {
  const padded = str + "=".repeat((4 - (str.length % 4)) % 4);
  return atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
}

export function encodeData(data) {
  const json = JSON.stringify(data);
  const encrypted = xorEncrypt(json, process.env.REACT_APP_SECRET_KEY);
  let encoded = base64UrlEncode(encrypted);

  return encoded;
}

export function decodeData(encoded) {
  const decrypted = base64UrlDecode(encoded);
  const original = xorEncrypt(decrypted, process.env.REACT_APP_SECRET_KEY);
  return JSON.parse(original);
}

export const downloadTemplate = (csvContent, filename = "template.csv") => {
  if (csvContent) {
    let hiddenElement = document.createElement("a");
    hiddenElement.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent),
    );
    hiddenElement.setAttribute("download", filename);
    document.body.appendChild(hiddenElement);
    hiddenElement.click();
    document.body.removeChild(hiddenElement);
  }
};

/**
 * Convert JSON array to CSV and download it
 * - Handles commas inside values
 * - Handles quotes and line breaks
 * - Supports nested objects/arrays
 */

export const exportJsonToCSV = (data = [], fileName = "export.csv") => {
  if (!Array.isArray(data) || data.length === 0) {
    console.error("No data found");
    return;
  }

  // Get all unique headers
  const headers = [...new Set(data.flatMap((obj) => Object.keys(obj)))];

  // Escape CSV values properly
  const escapeCSVValue = (value) => {
    if (value === null || value === undefined) return "";

    // Convert object/array to JSON string
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }

    value = String(value);

    // Escape double quotes
    value = value.replace(/"/g, '""');

    // Wrap in quotes so commas/newlines won't break columns
    return `"${value}"`;
  };

  // Create CSV rows
  const csvRows = [];

  // Header row
  csvRows.push(headers.map((val) => startCase(val)).join(","));

  // Data rows
  data.forEach((row) => {
    const values = headers.map((header) => escapeCSVValue(row[header]));

    csvRows.push(values.join(","));
  });

  // Final CSV content
  const csvContent = csvRows.join("\n");

  // Download CSV
  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
};

export function managerWiseStatus(obj) {
  if (obj.status == "pending") {
    if (!obj.approved_by1 && !obj.approved_by2) {
      return {
        rm1Status: "pending",
        rm2Status: "pending",
        finalStatus: "pending",
      };
    }
    if (obj.approved_by1 && !obj.approved_by2) {
      return {
        rm1Status: "approved",
        rm2Status: "pending",
        finalStatus: "pending",
      };
    }
  }
  if (obj.status == "approved") {
    if (!obj.approved_by1 && !obj.approved_by2) {
      return {
        rm1Status: "bypassed",
        rm2Status: "bypassed",
        finalStatus: "approved",
      };
    }
    if (!obj.approved_by1 && obj.approved_by2) {
      return {
        rm1Status: "bypassed",
        rm2Status: "approved",
        finalStatus: "approved",
      };
    }
    if (obj.approved_by1 && obj.approved_by2) {
      return {
        rm1Status: "approved",
        rm2Status: "approved",
        finalStatus: "approved",
      };
    }
  }
  if (obj.status == "rejected") {
    if (obj.approved_by1 && !obj.approved_by2) {
      return {
        rm1Status: "rejected",
        rm2Status: "bypassed",
        finalStatus: "rejected",
      };
    }
    if (!obj.approved_by1 && obj.approved_by2) {
      return {
        rm1Status: "bypassed",
        rm2Status: "rejected",
        finalStatus: "rejected",
      };
    }
    if (obj.approved_by1 && obj.approved_by2) {
      return {
        rm1Status: "approved",
        rm2Status: "rejected",
        finalStatus: "rejected",
      };
    }
    return {
      rm1Status: "bypassed",
      rm2Status: "bypassed",
      finalStatus: "rejected",
    };
  }
  if (obj.status == "cancelled") {
    return {
      rm1Status: obj.approved_by1 ? "approved" : "bypassed",
      rm2Status: obj.approved_by2 ? "cancelled" : "bypassed",
      finalStatus: "cancelled",
    };
  }
}
